<div>
  <div>
    <label for="newEmail">Nouvelle adresse email:</label>
    <input name="newEmail" type="email" [(ngModel)]="email"/>
  </div>
  <div>
    <label for="newEmailConfirm">Confirmation adresse email:</label>
    <input name="newEmailConfirm" type="email" [(ngModel)]="confirmEmail"/>
  </div>
  <div>
    <label for="newEmail">Mot de passe:</label>
    <input name="password" type="password" [(ngModel)]="password"/>
  </div>


  <div>
    <button (click)="validate()">Valider</button>
  </div>



</div>
